import * as actionTypes from 'constants/ActionTypes';

export function getSendEmailList(pagination) {
    return {
        type: actionTypes.GET_SEND_EMAIL_LIST.REQUEST,
        pagination,
    };
}

export function getSendEmail(id) {
    return {
        type: actionTypes.GET_SEND_EMAIL.REQUEST,
        id,
    };
}


// WEBPACK FOOTER //
// ./app/actions/sender.js